import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import {  exhaustMap, filter, map, mergeMap } from 'rxjs/operators';
import { APIResponse } from 'src/app/models/api-response.model';
import { SharedService } from 'src/app/services/shared.service';
import { failedTransaction } from '../actions/shared.actions';
import { tap } from 'rxjs/operators';

import * as fromSharedActions from 'src/app/store/actions/shared.actions'
import { OfflineStorageService } from 'src/app/services/offline-storage.service';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { ErrorComponent } from 'src/app/shared/modals/error/error.component';


@Injectable()
export class SharedEffects {
  failedTransaction$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(failedTransaction),
        tap(async (action) => {
          console.log('failedTransaction$', action.data);          
          const modal = await this.modalController.create({
            component: ErrorComponent,   
            cssClass: 'login-error-modal',
            componentProps: { error: action.data } 
          });
          await modal.present();
        })
      ),
    { dispatch: false }
  );

  getUnreadNotifications$ = createEffect(()=>{
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/bottom-tabs/inbox') || 
        r.payload.routerState.url.startsWith('/home/bottom-tabs/dashboard')
      }),
      exhaustMap(() => {
        console.log("pumasok ba here??");
        return this.sharedService.getUnreadNotification().pipe(
          map((response : APIResponse)=>{
            console.log('getUnreadNotifications$', response);
            console.log(response.details);
            return fromSharedActions.getUnreadNotificationSuccess({data : response.details});
          })
        )
      })
    )
  })

  getUserEvents$ = createEffect(() =>{
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/bottom-tabs/calendar');
      }),
      mergeMap(() => {
        return this.sharedService.getEventsList().pipe(
          map((response: APIResponse) => {
            console.log('getUserEvents$', response);
            return fromSharedActions.getUserEventsSucces({data: response});
          })
        );
      })
    )
  });

  reloadUserEvents$ = createEffect(() => {
    return this.actions$.pipe(
        ofType(fromSharedActions.reloadUserEvents),
        mergeMap(() => {
          return this.sharedService.getEventsList().pipe(
            map((response: APIResponse) => {
              console.log('getUserEvents$', response);
              return fromSharedActions.getUserEventsSucces({data: response});
            })
          );
        })
      )
    }
  );

  reorderDashboard$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromSharedActions.reorderDashboard),
        tap(async (action) => {
          this.store.dispatch(fromSharedActions.reorderDashboardSuccess({data: action?.data}));
        })
      ),
    { dispatch: false }
  );

  reorderDashboardSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromSharedActions.reorderDashboardSuccess),
        tap(async (action) => {
          this.offlineStorageService.setObject('currentOrder', action?.data)
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private sharedService: SharedService,
    private modalController: ModalController,
    private offlineStorageService: OfflineStorageService,
    private store: Store<AppState>
  ) {}
}
